export default {
  "Information.Title": "お知らせ一覧",
  "Information.Button": "トップページへ戻る",
}
